import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';

export default {
  'navBar.lang': '語言',
  'app.title': '研發效能平台',
  'app.header.documentation': '使用說明',
  'app.header.openapiDocumentation': 'OpenAPI 文件',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.copyright.produced': 'iMile',
  'app.preview.down.block': '下載此頁面至本機專案',
  'app.welcome.link.fetch-blocks': '取得所有區塊',
  'app.welcome.link.block-list': '以 block 開發，快速建置標準頁面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
